import { gql } from 'apollo-boost'

export const PROFILE = gql`
  query profile {
    profile {
      name
      avatar
    }
  }
`
